export default __webpack_public_path__ + "static/media/SapphireIcon.8f61738c.png";